import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Testimonials.module.css';
import Button from '../button/Button';

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    id: 1,
    name: 'טל בומץ',
    message: 'אני מרוצה! אני מרגיש שמטפלים בי טוב. רוית גם מאוד זמינה לי. היא נותנת תפוקה טובה ואני מרגיש שהיעילות שלה מאוד משתפרת. יש לה יחסי אנוש נהדרים גם מולי וגם מול האנשים שלי וגם מול האנשים המיוחדים שלי שזה לא מובן מאליו. היא מאוד חיובית, יודעת גם לקבל ביקורת, לוקחת את זה ברצינות ואני מרגיש שהיא מסורה וזה הרבה דברים טובים.',
    position: 'right'
  },
  {
    id: 2,
    name: 'יוסי אמודאי',
    message: 'יש לי חברת השקעות. קרן והמשרד מנהלות לי את העסק כבר 8 שנים. אני לא רואה את עצמי מסתדר בלי המשרד. 50% מהדברים שהן עושות אני בכלל לא מעורב אפילו. זו אופרציה שלמה שהן מנהלות. אם אני הייתי מתעסק רק עם הדיירים 50% היו עוזבים מזמן. ממליץ בחום על השירות.',
    position: 'left'
  },
  {
    id: 3,
    name: 'טרסה עיצוב חוץ',
    message: 'קרן אהובה את בדיוק כמו השם שלך מאירה כל מקום שאת בו. מפיצה טוב, רוך, הומור וחוכמה. בזכותך הכל נהיה קצת יותר קל, יותר חם, יותר אמיתי. אנחנו מעריכים אותך כל כך. את לא סתם מזכירת על - את חברה, את אור, את לב את נדירה',
    position: 'right'
  },
  {
    id: 4,
    name: 'דוט הנדסה',
    message: 'אין עליכן! צוות מנצח! כיף לעבוד אתכן!!',
    position: 'left'
  },
  {
    id: 5,
    name: 'דר גארדן',
    message: 'סומך עליכן! אלופות! אני בדיוק בשעה הזו הורדתי לחצים של חודש דחוס בזכותכן תודה על הכל',
    position: 'right'
  },
];

const TestimonialsMessages = () => {
  const sectionRef = useRef(null);
  const messagesRef = useRef([]);

  useEffect(() => {
    const messages = messagesRef.current;
    
    gsap.set(messages, {
      opacity: 0,
      y: 60,
      scale: 0.9,
    });

    messages.forEach((message, index) => {
      const isRight = testimonials[index].position === 'right';
      
      gsap.fromTo(message,
        {
          opacity: 0,
          x: isRight ? 80 : -80,
          y: 30,
          scale: 0.9,
          rotateY: isRight ? 10 : -10,
        },
        {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1,
          rotateY: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: message,
            start: 'top 85%',
            end: 'top 50%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    });

    const decorElements = sectionRef.current.querySelectorAll(`.${styles.decorCircle}`);
    decorElements.forEach((elem, i) => {
      gsap.to(elem, {
        y: (i % 2 === 0) ? -30 : 30,
        x: (i % 3 === 0) ? 20 : -20,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.backgroundDecor}>
        <div className={`${styles.decorCircle} ${styles.circle1}`}></div>
        <div className={`${styles.decorCircle} ${styles.circle2}`}></div>
        <div className={`${styles.decorCircle} ${styles.circle3}`}></div>
        <div className={styles.noiseOverlay}></div>
      </div>

      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title} id="מה אומרים עלינו">מה אומרים עלינו</h2>
        </div>

        <div className={styles.messagesContainer}>
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              ref={(el) => (messagesRef.current[index] = el)}
              className={`${styles.messageWrapper} ${
                testimonial.position === 'right' ? styles.alignRight : styles.alignLeft
              }`}
            >
              <div className={styles.messageCard}>
                <div className={styles.glassLayer}></div>
                <div className={styles.messageContent}>
                  <div className={styles.messageHeader}>
                    <div className={styles.avatar}>
                      <span>{testimonial.name.charAt(0)}</span>
                    </div>
                    <div className={styles.senderInfo}>
                      <span className={styles.senderName}>{testimonial.name}</span>
                    </div>
                  </div>
                  <p className={styles.messageText}>{testimonial.message}</p>
                  <div className={styles.messageTail}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Button text="לעוד פרטים על השירותים שלנו לחץ כאן"/>
    </section>
  );
};

export default TestimonialsMessages;